<template>
    <div
        class="uk-height-1-1 uk-width-1-1 uk-background-primary uk-border-rounded uk-box-shadow-small uk-padding-small graph-container"
    >
        <div class="graph-buttons uk-width-1-1">
            <graph-help :graph-id="id" />
        </div>

        <!-- <graph-submenu :position="graphPosition" /> -->

        <div class="uk-position-medium uk-position-top-left">
            <span class="uk-text-large uk-text-lead uk-text-bolder">{{ timeLocal }}</span>
            <span
                v-if="difference !== 0"
                class="uk-text-small margin-left-small"
                :class="{ 'uk-text-danger': difference < 0, 'uk-text-success': difference > 0 }"
            >
                <i :class="{ 'rotate-135': difference < 0, 'rotate-45': difference > 0 }">
                    <img
                        :src="require('@/assets/images/icons/icon-arrow-up.svg')"
                        class="transition-transform"
                        :class="{
                            'rotate-90': difference > 0,
                            'uk-fill-danger': difference < 0,
                        }"
                        uk-svg
                    />
                </i>
                {{ differenceLocal }}%
            </span>
            <span v-else>
                <span class="uk-text-warning margin-left-small"> {{ differenceLocal }}% </span> </span
            ><br />
            <span class="uk-text-meta uk-padding-top-60 uk-position-center-left uk-width no-wrap">{{ title }}</span>
        </div>

        <line-part :chart-data="getChartData" :is-time-y-axis="true" />

        <slot />

        <graph-modal :graph-id="id" :title="title" :description="description" />
    </div>
</template>

<script lang="js">
import LinePart from "./graphParts/LinePart.vue";
import GraphsMixin from "@/mixins/graphs-mixin";
import GraphSubmenu from "./graphParts/GraphSubmenu.vue";
import { Duration } from "luxon";
import GraphHelp from "./graphParts/GraphHelp.vue";
import GraphModal from "./graphParts/GraphModal.vue";

export default {
    name: "TimeLineGraph",
    components: { LinePart, GraphSubmenu, GraphHelp, GraphModal },
    mixins: [GraphsMixin],
    computed: {
        timeLocal() {
            return Duration.fromObject({ seconds: Math.round(this.aggregatedValue) }).toFormat("hh:mm:ss");
        },
        differenceLocal() {
            this.difference = this.difference * -1;
            return this.$formatNumber(Math.abs(this.difference));
        },
    },
};
</script>
